import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import axios from 'axios';
import { useHotelContext } from '../hotel_mapping/HotelContext';
import { Select, Button, Table, Input, List, notification, Card, Collapse } from 'antd';
import SearchApplicationClient from '@elastic/search-application-client';
import './UploadPage.css';
// import finkraft from '../images/finkraft.png';
import { LinkOutlined } from '@ant-design/icons';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const { Option } = Select;
const { Panel } = Collapse;

const client = new SearchApplicationClient(
  'HotelNameSearch',
  'https://88f84af300b542ef829bf72245776ad4.centralindia.azure.elastic-cloud.com:9243',
  'UXRQaEg1TUJFSVB0bkxodzh1RHc6ZEhWMW5ZOHFUM3FEbFQ5WmhMUmlKdw=='
);

const UploadPage = () => {
  const { hotelData, setHotelData, selectedHotelDetails, setSelectedHotelDetails } = useHotelContext();
  const [databases, setDatabases] = useState([]);
  const [collections, setCollections] = useState([]);
  const [keys, setKeys] = useState([]);
  const [uniqueValues, setUniqueValues] = useState([]);
  const [selectedDatabase, setSelectedDatabase] = useState('');
  const [selectedCollection, setSelectedCollection] = useState('');
  const [selectedKey, setSelectedKey] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [currentHotelName, setCurrentHotelName] = useState('');
  const [selectedGstin, setSelectedGstin] = useState([]);
  const [editableGstin, setEditableGstin] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMongoHotelDetails, setSelectedMongoHotelDetails] = useState({ name: '', id: '' });
  const [isSearchResultSelected, setIsSearchResultSelected] = useState(false);
  const [updatedHotels, setUpdatedHotels] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    axios.get('https://hotel-recon-system.finkraftai.com/api2/databases')
      .then(response => setDatabases(response.data))
      .catch(error => {
        console.error('Failed to fetch databases', error);
        notification.error({
          message: 'Data Retrieval Error',
          description: 'There is a problem in retrieving the data. Please try again later.',
        });
      });
  }, []);

  const fetchMongoData = () => {
    if (selectedDatabase && selectedCollection && selectedKey) {
      axios.get(`https://hotel-recon-system.finkraftai.com/api2/data?dbName=${selectedDatabase}&collectionName=${selectedCollection}&key=${selectedKey}`)
        .then(response => {
          const formattedData = response.data.map(item => ({
            selectedKey: item.selectedKey || '',
            selectedId: '',
            selectedGstin: ''
          }));
          setUniqueValues(formattedData);
        })
        .catch(error => {
          console.error('Failed to fetch data from MongoDB', error);
          notification.error({
            message: 'Error',
            description: 'There is some error in Mongo data. Please try again later.',
          });
        });
    }
  };

  const handleSelectDatabase = (value) => {
    setSelectedDatabase(value);
    setCollections([]);
    setKeys([]);
    setUniqueValues([]);
    setSelectedCollection('');
    setSelectedKey('');
  
    axios.get(`https://hotel-recon-system.finkraftai.com/api2/collections?dbName=${value}`)
      .then(response => {
        setCollections(response.data);
      })
      .catch(error => {
        console.error(`Failed to fetch collections for database ${value}`, error);
        notification.error({
          message: 'Error',
          description: 'There is some error in Mongo data. Please try again later.',
        });
      });
  };
  
  const handleSelectCollection = (value) => {
    setSelectedCollection(value);
    setKeys([]);
    setUniqueValues([]);
    setSelectedKey('');
  
    axios.get(`https://hotel-recon-system.finkraftai.com/api2/keys?dbName=${selectedDatabase}&collectionName=${value}`)
      .then(response => {
        setKeys(response.data);
        fetchMongoData();
      })
      .catch(error => {
        console.error(`Failed to fetch keys for collection ${value}`, error);
        notification.error({
          message: 'Error',
          description: 'There is some error in Mongo data. Please try again later.',
        });
      });
  };

  const handleSelectKey = (value) => {
  setSelectedKey(value);
  setUniqueValues([]); 

  axios.get(`https://hotel-recon-system.finkraftai.com/api2/all-values?dbName=${selectedDatabase}&collectionName=${selectedCollection}&key=${value}`)
    .then(response => {
      const formattedData = response.data.map(item => ({
        id: item.id,
        name: item.value,
        primary_key: item.primary_key,
        primary_gstin: item.primary_data_value?.primary_gstin ?? 'N/A',
      }));

      console.log("Formatted Data:", response);
      setUniqueValues(formattedData);
    })
    .catch(error => {
      console.error(`Failed to fetch values for key ${value}`, error);
      notification.error({
        message: 'Error',
        description: 'There is some error in Mongo data. Please try again later.',
      });
    });
};

  const filteredHotels = uniqueValues
    .filter(item => (
      item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase())
    ))
    .map(item => ({ name: item.name, id: item.id, primary_key: item.primary_key, primary_gstin: item.primary_gstin }));


  const handleelastic = async (queryStr) => {
    setCurrentHotelName(queryStr);

    const esUrl = "https://88f84af300b542ef829bf72245776ad4.centralindia.azure.elastic-cloud.com:9243";

    const searchQuery = {
      size: 10000,
      query: {
        query_string: {
          query: `${queryStr}`,
          fields: ["*"],
          default_operator: "AND",
          fuzziness: "AUTO",
          analyze_wildcard: false,
          lenient: true,
        },
      },
    };

    try {
      const response = await axios.post(
        `${esUrl}/mongofinkraft/_search`,
        searchQuery,
        {
          headers: {
            Authorization: "apiKey WUZyclpaSUJnR0FRZTlTZ2xYazQ6eWR3VnRMd1FTaXktN2hEb05MN2JVUQ==",
          },
        }
      );

      const retrievedResults = response.data?.hits.hits.map(hit => ({
        id: hit._id,
        score: hit._score,
        name: hit._source['Hotel Name'],
        gstin: Array.isArray(hit._source['Hotel GSTIN']) ? hit._source['Hotel GSTIN'].join(', ') : hit._source['Hotel GSTIN'],
        zoho_crm_id: hit._source?.zoho_crm_id ?? null,
        all_data: hit._source
      }));
      if (!retrievedResults || retrievedResults.length === 0) {
        notification.warning({
          message: 'No Data Found',
          description: 'No data was found for the selected hotel in Elastic Search.',
        });
      }

      setSearchResults(retrievedResults);
      setIsModalVisible(true);

      console.log("++++++++", response);
    } catch (error) {
      console.error("Error fetching Elastic Search results:", error);
      notification.error({
        message: 'Error',
        description: 'There is an error in querying the Elastic Search. Please check the configuration.',
      });
    }
  };
  const handleSelect = (hotel) => {
    const cleanedHotelName = hotel.name.replace(/^"|"$/g, '').replace(/^'|'$/g, '');
    setSelectedMongoHotelDetails(hotel)
    setIsSearchResultSelected(false);

    console.log("Cleaned Hotel Name: ", cleanedHotelName);
    handleelastic(cleanedHotelName)

  };

  const handleRowClick = (record) => {
    setSelectedHotelDetails({ name: record.name, id: record.id, gstin: record.gstin, zoho_crm_id: record.zoho_crm_id, });
    setIsSearchResultSelected(true);

    console.log("Search Result Selected Record:", record);

    const gstinArray = Array.isArray(record.gstin) ? record.gstin : record.gstin.split(',').map(s => s.trim());
    setSelectedGstin(gstinArray);

    setEditableGstin('');
    setSelectedRowData(record.all_data);
  };

  const handleExportJson = () => {
    if (!editableGstin) {
      notification.warning({
        message: 'Warning',
        description: 'Please select the primary GSTIN before updating the data.',
      });
      return;
    }

    const searchDetails = selectedHotelDetails;
    const mongoDetails = selectedMongoHotelDetails;

    if (!searchDetails.name || !searchDetails.id) {
      console.error('One or both of the selections are missing');
      return;
    }

    const dataToSend = {
      searchDetails: {
        hotelName: searchDetails.name,
        hotelId: searchDetails.id,
        selectedGstin: editableGstin || 'N/A',
        details: mongoDetails,
        database: selectedDatabase,
        collection: selectedCollection
      },
    };

    axios.post('https://hotel-recon-system.finkraftai.com/api2/export', dataToSend)
      .then(response => {
        if (response.status === 200) {
          notification.success({
            message: 'Success',
            description: 'Data updated successfully.',
          });

          setUpdatedHotels([...updatedHotels, selectedMongoHotelDetails.id]);
        } else {
          notification.error({
            message: 'Error',
            description: 'There is an error in data. Please try again.',
          });
        }
      })
      .catch(error => {
        console.error('Error sending data to the server:', error);
        notification.error({
          message: 'Error',
          description: 'There is an error in data. Please try again.',
        });
      });
  };
  const handleGstinClick = (gstin) => {
    setEditableGstin(gstin);
  };

  const columnDefs = [
    { headerName: "Hotel Name", field: "name", filter: true },
    { headerName: "Hotel GSTIN", field: "gstin", filter: true },
    {
      headerName: "No. of GSTIN",
      valueGetter: (params) => {
        const gstin = params.data.gstin;
        return gstin ? gstin.split(',').length : 0;
      }
    },
    { headerName: "ID", field: "id" },
    { headerName: "Score", field: "score", filter: true },
  ];

  console.log("Search result: ", searchResults)

  return (
    <div className="upload-page">
      <div className="sidebar">
        <div className='upload-page-select'>
          <div className="database">
            <div className="select-container">
              <h6>Select Database</h6>
              <Select
                className='drop_down'
                placeholder="Select a database"
                showSearch
                onChange={handleSelectDatabase}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {databases.map((db) => (
                  <Option key={db} value={db}>{db}</Option>
                ))}
              </Select>
            </div>

            <div className="select-container">
              <h6>Select Collection</h6>
              <Select
                className='drop_down'
                placeholder="Select a collection"
                showSearch
                onChange={handleSelectCollection}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {collections.map((collection) => (
                  <Option key={collection} value={collection}>{collection}</Option>
                ))}
              </Select>
            </div>
          </div>

          <div className='database1'>
            <h6>Select Key</h6>
            <Select
              className='drop_down'
              placeholder="Select a key"
              showSearch
              onChange={handleSelectKey}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {keys.map((key) => (
                <Option key={key} value={key}>{key}</Option>
              ))}
            </Select>
          </div>
        </div>
        {uniqueValues.length > 0 && (
          <div className='list'>
            <h6>{selectedKey.toUpperCase()}</h6>
            <Input
              placeholder="Search hotels"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ marginBottom: '10px' }}
            />
            <div className='list'>
              <List
                className='hotel-name-list'
                bordered
                dataSource={filteredHotels}
                renderItem={hotel => (
                  <List.Item
                    onClick={() => handleSelect(hotel)}
                    style={{
                      backgroundColor: updatedHotels.includes(hotel.id) ? 'lightgreen' : (hotel.primary_key ? 'lightgreen' : 'inherit'),
                      cursor: 'pointer',
                      padding: '10px',
                      borderRadius: '4px',
                      marginTop: "2px",
                    }}
                  >
                    {hotel.name}
                  </List.Item>
                )}
              />
            </div>
          </div>
        )}
      </div>

      <div className="divider"></div>
      <div className="content">
        {searchResults.length > 0 && (
          <div className="results-table-container ag-theme-alpine" >
            <h6>Elastic Results</h6>
            <AgGridReact
              columnDefs={columnDefs}
              rowData={searchResults}
              domLayout='autoHeight'
              onRowClicked={({ data }) => handleRowClick(data)}
              suppressColumnVirtualisation={true}
              animateRows={true}
              pagination={true}
              paginationPageSize={10}
              paginationAutoPageSize={false}
            />
          </div>
        )}
        {isSearchResultSelected && selectedGstin.length > 0 && (
          <div className="details-panel">
            <div style={{ display: "flex", gap: '20px' }}>
              <h6>Select Primary GSTIN</h6>
              <Button
                type="primary"
                onClick={handleExportJson}
                disabled={!editableGstin}
                className='upload-page-button'
              >
                Update the data
              </Button>
            </div>
            <div className="gstin-list-container">
              <List
                bordered
                dataSource={selectedGstin}
                renderItem={(gstin) => (
                  <List.Item onClick={() => handleGstinClick(gstin)}>
                    {gstin}
                  </List.Item>
                )}
                style={{ cursor: 'pointer', flex: '1' }}
              />
            </div>
            <div style={{ marginTop: '20px' }}>
              <h6>Primary Gstin</h6>
              <Input
                value={editableGstin}
                onChange={(e) => setEditableGstin(e.target.value)}
                placeholder="Edit GSTIN"
              />
            </div>
            <div style={{ marginTop: '20px' }}>
              <h6>Zoho CRM</h6>
              {selectedHotelDetails.zoho_crm_id ? (
                <a
                  href={`https://crm.zoho.in/crm/org60016690758/tab/Accounts/${selectedHotelDetails.zoho_crm_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-style"
                >
                  <LinkOutlined style={{ marginRight: '8px', color:"lightgray" }} />
                  {selectedHotelDetails.name}
                </a>
              ) : (
                <div>N/A</div>
              )}
            </div>
            {selectedRowData && (
              <div className="record-details">
                <h6>Record Details</h6>
                <Table
                  dataSource={Object.entries(selectedRowData).map(([key, value]) => ({
                    data: key,
                    value: typeof value === 'object' ? JSON.stringify(value) : value,
                  }))}
                  rowKey="data"
                  pagination={false}
                  scroll={{ y: 240 }}
                  columns={[
                    {
                      title: 'Data',
                      dataIndex: 'data',
                      key: 'data',
                    },
                    {
                      title: 'Value',
                      dataIndex: 'value',
                      key: 'value',
                    },
                  ]}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

};

export default UploadPage;